module.exports = __webpack_public_path__ + "img/businessImg11.c7233eaf.png";